import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineFolderDownloadIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="m13.29 13.79-.29.3V11.5a1.0001 1.0001 0 0 0-2 0v2.59l-.29-.3a1.0041 1.0041 0 1 0-1.42 1.42l2 2c.0951.091.2072.1624.33.21a.94.94 0 0 0 .76 0 1.0002 1.0002 0 0 0 .33-.21l2-2a1.0041 1.0041 0 1 0-1.42-1.42ZM19 5.5h-6.28l-.32-1a3 3 0 0 0-2.84-2H5a3 3 0 0 0-3 3v13a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-10a3 3 0 0 0-3-3Zm1 13a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-13a1 1 0 0 1 1-1h4.56a.9999.9999 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .95.68h7a1 1 0 0 1 1 1v10Z"/>
  </SvgIcon>
}

export default LineFolderDownloadIcon
